import { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/config';

export const useBlogList = ({ page = 1, category, search } = {}) => {
  const [data, setData] = useState({ items: [], total: 0, totalPages: 1, page: 1 });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams({ page });
    if (category && category !== 'All') qs.set('category', category);
    if (search) qs.set('search', search);
    axios
      .get(`${BASE_URL}/blog?${qs}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ items: [], total: 0, totalPages: 1, page: 1 }))
      .finally(() => setLoading(false));
  }, [page, category, search]);
  return { ...data, loading };
};

// Newsletter sign-up. The backend is idempotent, so a repeat address comes back
// as a normal success with alreadySubscribed = true.
export const subscribeToNewsletter = (email) =>
  axios
    .post(`${BASE_URL}/blog/subscribe`, { email, source: 'blog' })
    .then((r) => r.data);

export const useBlogPost = (slug) => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    axios
      .get(`${BASE_URL}/blog/slug/${slug}`)
      .then((r) => setPost(r.data))
      .catch((e) => {
        if (e.response?.status === 404) setNotFound(true);
      })
      .finally(() => setLoading(false));
  }, [slug]);
  return { post, loading, notFound };
};

export const useBlogCategories = () => {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    axios
      .get(`${BASE_URL}/blog/categories`)
      .then((r) => setCats(r.data))
      .catch(() => setCats([]));
  }, []);
  return cats;
};
